var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('DataList',{attrs:{"data":_vm.conductorConfig,"attributes":_vm.attributes}}),_c('RawJsonToggler',{attrs:{"json":_vm.conductorConfig}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }